/** Fallback unificado quando min_stock não está definido (alinhado ao backend). */
export const DEFAULT_MIN_STOCK = 0

/**
 * Estoque disponível para venda no e-commerce: físico menos reservado (pré-vendas, etc.).
 */
export function getAvailableUnitsFromProduct(product) {
  if (!product || typeof product !== 'object') return 0
  if (
    product.stock_available != null &&
    !Number.isNaN(Number(product.stock_available))
  ) {
    return Math.max(0, Math.floor(Number(product.stock_available)))
  }
  const q = Number(product.stock_quantity) || 0
  const r = Number(product.stock_reserved) || 0
  return Math.max(0, Math.floor(q - r))
}

/** Produto com estoque disponível para venda (> 0). */
export function isProductInStock(product) {
  return getAvailableUnitsFromProduct(product) > 0
}

/**
 * Ordena com estoque positivo primeiro (estável entre iguais).
 * Preferência do e-commerce: vender o que tem, OOS no fim.
 */
export function sortProductsInStockFirst(products) {
  if (!Array.isArray(products) || products.length < 2) {
    return Array.isArray(products) ? [...products] : []
  }
  return [...products].sort((a, b) => {
    const stockA = getAvailableUnitsFromProduct(a)
    const stockB = getAvailableUnitsFromProduct(b)
    const inA = stockA > 0 ? 1 : 0
    const inB = stockB > 0 ? 1 : 0
    if (inA !== inB) return inB - inA
    return stockB - stockA
  })
}

/**
 * @param {number | string | null | undefined} minStock
 * @returns {number}
 */
export function getEffectiveMinStock(minStock) {
  if (minStock == null || minStock === '') return DEFAULT_MIN_STOCK
  const parsed = Number(minStock)
  return Number.isFinite(parsed) ? parsed : DEFAULT_MIN_STOCK
}

/**
 * Produto abaixo do estoque mínimo (mesma regra do dashboard ERP e compras).
 * @param {{ min_stock?: number, stock_quantity?: number, stock_reserved?: number, stock_available?: number } | null | undefined} product
 * @returns {boolean}
 */
export function isBelowMinimumStock(product) {
  const minStock = getEffectiveMinStock(product?.min_stock)
  if (minStock <= 0) return false
  return getAvailableUnitsFromProduct(product) < minStock
}
